<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <el-form ref="form" :model="dioForm" :rules="rules" label-width="160px">
            <el-form-item :label="$t('public.table_scope')" prop="sceneId" v-if="sysAdmin === 'isSysAdmin' || sysAdmin === 'isSysNoAdmin'">
                <el-select v-model="dioForm.sceneId" style="width: 250px">
                    <el-option v-for="item in scopeArrays" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('device.display_name')" prop="name">
                <el-input v-model.trim="dioForm.name" style="width: 250px" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('device.display_nickname')" prop="nickname">
                <el-input v-model.trim="dioForm.nickname" style="width: 250px" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('integration.display_number')" prop="displayCode">
                <el-input v-model.trim="dioForm.displayCode" style="width: 250px" maxlength="30" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('device.display_type')" prop="type">
                <el-select v-model="dioForm.type" style="width: 250px">
                    <el-option v-for="item in deviceDisplayType" :key="item.id" :label="`${$t(deviceTypeListConvert[item.code])}`"
                     :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('device.time_zone')" prop="timeCode">
                <el-select v-model="dioForm.timeCode" style="width: 250px">
                    <el-option v-for="item in shiquArrays" :key="item.code"
                        :label="`${$t(shiquArrayConvert(item.code))}`" :value="item.code"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('integration.switch_settings')" prop="alarmOn">
                <el-checkbox v-model="dioForm.alarmOn" :true-label="1" :false-label="0"></el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('integration.duration_(seconds)')" prop="alarmPeriod" v-if="dioForm.alarmOn">
                <el-input v-model.trim="dioForm.alarmPeriod" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('integration.time_interval_(seconds)')" prop="alarmInterval" v-if="dioForm.alarmOn">
                <el-input v-model.trim="dioForm.alarmInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('Ext Pan ID')" prop="extPanId" :rules="RuleExtPanId">
                <el-input v-model.trim="dioForm.extPanId" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('Join Attemp')" prop="channelPage" :rules="RuleChannelPage">
                <el-input v-model.trim="dioForm.channelPage" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('device.transmit_power')" prop="transmitPower">
                <el-input v-model.trim="dioForm.transmitPower" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('device.channel_mask')" prop="channelMask" :rules="RuleChannelMask">
                <el-input v-model.trim="dioForm.channelMask" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('device.in_net_interval')" prop="inNetInterval">
                <el-input v-model.trim="dioForm.inNetInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('public.table_desc')" prop="description">
                <el-input
                    v-model.trim="dioForm.description"
                    style="width: 250px"
                    type="textarea"
                    maxlength="250"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    show-word-limit
                    :placeholder="$t('public.please_enter')"
                />
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { addDisplay, editDisplay } from '@/api/modules/display.js';
import { RuleExtPanId, RuleChannelPage, RuleChannelMask } from '@/utils/rules';
import { deviceTypeListConvert,shiquArrayConvert } from '@/utils/convert'

export default {
    props: ['isShow', 'title', 'scopeArray', 'editRow', 'shiquArray', 'deviceDisplayType'],
    watch: {
        scopeArray(newVal) {
            this.scopeArrays = [...newVal];
        },
        shiquArray(newVal) {
            this.shiquArrays = [...newVal];
        },
        editRow(newVal) {
            const {
                sceneId,
                displayCode,
                type,
                typeCode,
                name,
                nickname,
                timeCode,
                alarmOn,
                alarmInterval,
                alarmPeriod,
                extPanId,
                channelPage,
                inNetInterval,
                transmitPower,
                channelMask,
                description,
                id
            } = newVal;
            this.dioForm = {
                sceneId: sceneId + '',
                displayCode,
                type,
                typeCode,
                name,
                nickname,
                timeCode,
                alarmOn,
                alarmInterval,
                alarmPeriod,
                extPanId,
                channelPage,
                inNetInterval,
                transmitPower,
                channelMask,
                description,
                id
            };
        }
    },
    computed: {
        deviceTypeListConvert: () => deviceTypeListConvert,
        shiquArrayConvert: () => shiquArrayConvert,

        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        },
        /** 用于表示当前登录用户属于什么类型的角色 */
        sysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            if (currentUser.sysScope && currentUser.sysAdmin) {
                //系统管理员
                return 'isSysAdmin';
            } else if (currentUser.sysScope && !currentUser.sysAdmin) {
                //系统非管理员
                return 'isSysNoAdmin';
            } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
                //非系统管理员 以及代理角色  代理角色是迭代7的需求添加
                return 'noSysIsAdmin';
            } else {
                //非系统非管理员
                return 'noSysNoAdmin';
            }
        },
        rules() {
            let channelMask = function(rules, value, callback) {
                const reg = /^\d+([,]\d+)*$/;
                if (!reg.test(String(value))) {
                    callback(new Error($t('integration.multiple_combined_numbers_are_separated_by_commas_and_are_numbers')));
                } else {
                    let array = String(value).split(',');
                    for (let item of array) {
                        if (parseInt(item) > 255 || parseInt(item) < 1) {
                            callback('存在不在1-255范围的值');
                        }
                    }
                    callback();
                }
            };
            let channelMask2 = function(rules, value, callback) {
                let reg = /^\d{1,}$/;
                if (value <= 0 || value > 16777215) {
                    callback('范围值在1-167771215');
                } else if (!reg.test(value)) {
                    callback($t('integration.only_numbers_can_be_entered'));
                } else {
                    callback();
                }
            };
            return {
                sceneId: [{ required: true, message: $t('integration.customer_cannot_be_empty'), trigger: 'change' }],
                type: [{ required: true, message: $t('integration.display_type_cannot_be_empty'), trigger: 'change' }],
                timeCode: [{ required: true, message: $t('integration.time_zone_cannot_be_empty'), trigger: 'change' }],
                name: [
                    { required: true, message: $t('integration.the_display_name_cannot_be_empty'), trigger: 'blur' },
                    { max: 80, message: $t('integration.length_cannot_exceed_80'), trigger: 'blur' }
                ],
                nickname: [
                    { required: true, message: $t('integration.screen_nickname_cannot_be_empty'), trigger: 'blur' },
                    { max: 30, message: $t('public.len_max_30'), trigger: 'blur' }
                ],
                displayCode: [
                    { required: true, message: $t('integration.the_display_number_cannot_be_empty'), trigger: 'blur' },
                    { max: 30, message: $t('public.len_max_30'), trigger: 'blur' }
                ],
                extPanId: [
                    { required: true, message: $t('integration.extpanid_cannot_be_empty'), trigger: 'blur' },
                    { max: 18, message: $t('integration.the_length_is_8_hex_bases_c__i_dot_e_dot__18'), trigger: 'blur' },
                    {
                        validator: this.$fromRules.FormValidate.Form().Code,
                        trigger: 'blur'
                    }
                ],
                channelPage: [
                    { required: true, message: 'Join Attemp不能为空', trigger: 'blur' },
                    {
                        validator: this.$fromRules.FormValidate.maxMinFn('channelPage').netRule
                    }
                ],
                channelMask: [
                    { required: true, message: $t('integration.channel_mask_cannot_be_empty'), trigger: 'blur' },
                    {
                        validator: channelMask,
                        trigger: 'blur'
                    }
                ],
                transmitPower: [
                    { required: true, message: $t('integration.transmit_power_cannot_be_empty'), trigger: 'blur' },
                    {
                        validator: this.$fromRules.FormValidate.maxMinFn('channelPage').netRule,
                        trigger: 'blur'
                    }
                ],
                inNetInterval: [
                    { required: true, message: $t('integration.the_network_access_interval_cannot_be_empty'), trigger: 'blur' },
                    {
                        validator: channelMask2,
                        trigger: 'blur'
                    }
                ],
                alarmPeriod: [
                    { required: true, message: $t('integration.duration_cannot_be_empty'), trigger: 'blur' },
                    {
                        validator: channelMask2,
                        trigger: 'blur'
                    }
                ],
                alarmInterval: [
                    { required: true, message: $t('integration.time_cannot_be_empty'), trigger: 'blur' },
                    {
                        validator: channelMask2,
                        trigger: 'blur'
                    }
                ]
            };
        }
    },
    data() {
        return {
            dioForm: {
                sceneId: null,
                displayCode: null,
                type: null,
                typeCode: null,
                name: null,
                nickname: null,
                timeCode: null,
                alarmOn: 0,
                alarmInterval: null,
                alarmPeriod: null,
                extPanId: '50414e4944303032',
                channelPage: '0',
                inNetInterval: '900',
                transmitPower: '17',
                channelMask: '11',
                description: null
            },
            scopeArrays: [],
            shiquArrays: [],
            RuleExtPanId,
            RuleChannelPage,
            RuleChannelMask
        };
    },
    created() {
        console.log(this.deviceDisplayType);
    },
    methods: {
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate();
            } catch (error) {
                return false;
            }
        },
        async handleSave() {
            let flag = await this.justify();
            if (!flag) return;
            let httpUrl = addDisplay;
            if (this.dioForm.id) {
                httpUrl = editDisplay;
            } else {
                delete this.dioForm.id;
                for (let item of this.deviceDisplayType) {
                    if (this.dioForm.type === Number(item.value)) {
                        this.dioForm.typeCode = item.code;
                        break;
                    }
                }
            }
            this.dioForm['sceneId'] = this.dioForm['sceneId'] || this.$store.state.userInfo.scope['sceneId'];
            httpUrl(this.dioForm).then(async ({ state }) => {
                await this.$resultHandle(state);

                this.isShowDialog = false;
                this.$parent.getListFn();
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
    border-radius: 2px;
    margin-left: 5px;
}
</style>
